var template = require('../templates/intro.hbs');
var $ = require('jquery');
var getConfig = require('../lib/getConfig');
var getFileExtension = require('../lib/getFileExtension');

var Modernizr = window.Modernizr || {};

var content = {};
var playedOnce = false;

var view = function (config) {

  return new Promise(function (resolve, reject) {

    Modernizr.on('videoautoplay', function (videoautoplay) {



      if (videoautoplay && Modernizr.videoloop) {
        var videoAssets = config.assets.introvideo.map(function (videoURL) {
          return {
            src: videoURL,
            type: 'video/' + getFileExtension(videoURL)
          };
        });
        content.video = require('../templates/videoloop.hbs')(videoAssets);
      }

      var $wrapper = $('#appendHere');

      var $html = $(template(content));
      var $next = $html.find('#continue');

      $wrapper.html($html)
        .addClass('in');

      $next.on('click', function (e) {

        if (!playedOnce && !videoautoplay) {
          var mainVideo = document.getElementById('mainVideo');
          mainVideo.play();
          mainVideo.pause();
          mainVideo.currentTime = 0;
          playedOnce = true;
        }

        e.preventDefault();
        $wrapper.html('')
          .removeClass('in');
        resolve();
      });
    });
  });
};

module.exports = function () {
  return getConfig().then(view);
};
